<template>
  <div class="row margin-top-42 ml-0 mr-0 trailer-details">
    <div class="col-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id="trail_details"
            type="button"
            class="expand-form-button collapsed"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#trailerDetails"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Trailer Details</h3>
      </div>
    </div>
    <div class="col-12 pt-3">
      <div class="row color-even border py-3">
        <div class="col-xl-2 col-md-3 col-sm-4 col-6 pt-1 pr-0 pl-lg-3 pl-2">
          <span class="font-weight-bold pl-1 add-span" @click="addTrailer()" :class="{'disabled': !trailerDetailsData.trailerTowedBy.value}">
            <img alt="Add More Trailers" class="plus-img" src="@/assets/images/black.png" />
            Add More Trailers
          </span> 
        </div>
        <div class="col-xl-3 col-md-3 col-sm-4 col-6 pl-2 pr-0">
          <float-label label="Trailer Towed by" :fixed="isFloat(trailerDetailsData.trailerTowedBy.value)">
            <select class="form-control claimTextBox font-weight-bold" placeholder="Trailer Towed by" v-model="trailerDetailsData.trailerTowedBy.value" @change="changeTowedBy()"> 
              <option value="" disabled>Trailer Towed by</option>
              <option v-for="tow in trailerDetailsdb.trailerTowedBy" :key="tow.code" :value="tow.code">{{tow.name}}</option>          
            </select> 
          </float-label>
        </div>
        <div class="col-xl-7 col-md-6 col-sm-4 pl-0 col-12 pt-sm-0 pt-2">
          <span class="float-right font-value">Trailer Total Value: <b>0</b> </span>
        </div>
      </div>
      <div v-if="trailerDetailsData.trailers.length > 0">
        <div class="row d-none d-sm-block">
          <div class="col-12">
            <div class="row small-font">
              <div class="col border border-right-0 border-top-0 text-center py-2"><span >Trailer Capacity*</span> </div>
              <div class="col border border-right-0 border-top-0 text-center py-2"><span>Trailer Chassis No.*</span> </div>
              <div class="col border border-right-0 border-top-0 text-center py-2"><span>Trailer Registration No.*</span> </div>
              <div class="col border border-right-0 border-top-0 text-center py-2"><span>Trailer Sum Insured*</span> </div>
              <div class="col-1 p-0 border border-top-0 text-center py-2"><span>Delete Row</span> </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="row color-light " v-for="(trailerDetailsModel,index) in trailerDetailsData.trailers" :key="index">
              <div class="col-sm col-5 border-left border-bottom pt-3 pb-2 pr-0">
                <float-label label="Trailer Capacity*" :fixed='isFloat(trailerDetailsModel.trailerCapacity.value)'>
                  <input
                    @blur="checkError(trailerDetailsModel.trailerCapacity,false)"
                    v-model="trailerDetailsModel.trailerCapacity.value"
                    placeholder="Trailer Capacity*"
                    maxlength="20"
                    v-on:keydown="onlyNumber"
                    :class="{'bgc-error-field':trailerDetailsModel.trailerCapacity.errorText !== ''}"
                    type="text" class="form-control input-sm" />
                </float-label>
                <span
                  class="error-text"
                  v-if="trailerDetailsModel.trailerCapacity.errorText!==''"
                >{{trailerDetailsModel.trailerCapacity.errorText}}</span>
              </div>
              <div class="col-sm col-5 border-left border-bottom pt-3 pb-2 pr-0">
                <float-label label="Trailer Chassis No.*" :fixed='isFloat(trailerDetailsModel.trailerChassisNo.value)'>
                  <input
                    @blur="checkError(trailerDetailsModel.trailerChassisNo,false)"
                    v-model="trailerDetailsModel.trailerChassisNo.value"
                    maxlength="20"
                    v-on:keydown="alphaNumeric"
                    placeholder="Trailer Chassis No.*"
                    v-on:keyup="toUpperCase($event, index, 'chassis')"
                    :class="{'bgc-error-field':trailerDetailsModel.trailerChassisNo.errorText !== ''}"
                    type="text" class="form-control chassis-input" />
                </float-label>
                <span
                  class="error-text"
                  v-if="trailerDetailsModel.trailerChassisNo.errorText!==''"
                >{{trailerDetailsModel.trailerChassisNo.errorText}}</span>
              </div>
              <div class="col-2 d-block d-sm-none border-left border-right"></div>
              <div class="col-sm col-5 border-left border-bottom pt-3 pb-2 pr-0">
                <float-label label="Trailer Registration No.*" :fixed='isFloat(trailerDetailsModel.trailerRegistrationNo.value)'>
                  <input
                    @blur="checkError(trailerDetailsModel.trailerRegistrationNo,false)"
                    v-model="trailerDetailsModel.trailerRegistrationNo.value"
                    maxlength="20"
                    placeholder="Trailer Registration No.*"
                    v-on:keydown="alphaNumeric"
                    v-on:keyup="toUpperCase($event, index, 'registration')"
                    :class="{'bgc-error-field':trailerDetailsModel.trailerRegistrationNo.errorText !== ''}"
                    type="text" class="form-control trailer-reg-no" />
                </float-label>
                <span
                  class="error-text"
                  v-if="trailerDetailsModel.trailerRegistrationNo.errorText!==''"
                >{{trailerDetailsModel.trailerRegistrationNo.errorText}}</span>
              </div>
              <div class="col-sm col-5 border-left border-bottom pt-3 pb-2 pr-0">
                <float-label label="Trailer SumInsured*" :fixed='isFloat(trailerDetailsModel.trailerSumInsurd.value)'>
                  <input
                    @blur="checkError(trailerDetailsModel.trailerSumInsurd,false)"
                    v-model="trailerDetailsModel.trailerSumInsurd.value"
                    maxlength="20"
                    placeholder="Trailer SumInsured*"
                    disabled
                    v-on:keydown="onlyNumber"
                    :class="{'bgc-error-field':trailerDetailsModel.trailerSumInsurd.errorText !== ''}"
                    type="text" class="form-control" />
                </float-label>
                <span
                  class="error-text"
                  v-if="trailerDetailsModel.trailerSumInsurd.errorText!==''"
                >{{trailerDetailsModel.trailerSumInsurd.errorText}}</span>
              </div>
              <div class="col-2 col-sm-1 p-0 text-center delete-row border border-top-0" :class="{'disable-delete': trailerDetailsData.trailers.length == 1}">
                <img class="pt-1 delete-img" alt="Add More Trailers" src="@/assets/images/icon-trash@2x.png" @click="deleteTrailer(index)"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> 
</template>
<script>
  import FloatLabel from "@/../shared_component/FloatLabel.vue";
  import functions from '@/../../masters/functions.js';
  import {reactive, onMounted} from '@vue/composition-api';

  export default {
    name: "TrailerDetails",
    props:['trailerDetailsData','trailerDetailsdb'],
    components: {
      FloatLabel
    },
    setup(props , context){
      let state = reactive({
      })
      onMounted(()=>{
        props.trailerDetailsData.trailerTowedBy.value='NAGV'
        changeTowedBy()
      })
      function changeTowedBy(){
        if(props.trailerDetailsData.trailers.length == 0)
          addTrailer();
      }
      function toUpperCase(evt, index, calledFrom){
        if(calledFrom == 'registration'){
          props.trailerDetailsData.trailers[index].trailerRegistrationNo.value = evt.target.value.toUpperCase();
        }  
        else{
          props.trailerDetailsData.trailers[index].trailerChassisNo.value = evt.target.value.toUpperCase();
        }  
      }
      function addTrailer(){
        context.parent.addTrailer();
      }
      function deleteTrailer(index){
        if(props.trailerDetailsData.trailers.length > 1){
          props.trailerDetailsData.trailers.splice(index, 1);
        }
      }
      const onlyNumber =  functions.onlyNumber;
      const checkError = functions.checkError;
      const alphaNumeric = functions.alphaNumeric;
      const isFloat = functions.isFloat;
      return{
        state,
        addTrailer,
        deleteTrailer,
        checkError,
        onlyNumber,
        alphaNumeric,
        isFloat,
        toUpperCase,
        changeTowedBy
      }
    },
    directives: {
      evolvews: functions.evolvews,
    },
  };
</script>
<style scoped>
  .trailer-details{
    color:#333;
  }
  .disable-delete{
    pointer-events: none;
    opacity: 0.8;
  }
  select.claimTextBox {
    line-height: 22px;
    min-height: 17px;
    width: 140 px;
  }
  .color-even {
    background-color: rgba(30, 30, 30, 0.05);
  }
  input[type=text], [type=email], [type=date], [type=number], select.form-control {
    min-height: 34px;
    background-color: white;
  }
  .font-value{
    font-size: 24px;
  }
  .add-span{
    cursor: pointer;
  }
  .delete-img{
    cursor:pointer;
  }
  .color-light{
    background-color: rgba(30, 30, 30, 0.04);
  }
  .plus-img{
    padding-bottom: 4px;
    padding-right: 4px;
  }
  .disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
  .small-font{
    font-size: 14px;
  }
  .chassis-input, .trailer-reg-no{
    text-transform:uppercase;
  }
  ::-webkit-input-placeholder { /* WebKit browsers */
    text-transform: none;
  }
  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    text-transform: none;
  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    text-transform: none;
  }
  :-ms-input-placeholder { /* Internet Explorer 10+ */
    text-transform: none;
  }
  ::placeholder { /* Recent browsers */
    text-transform: none;
  }
  @media (max-width: 575px){
    .delete-img{
      position: relative;
      bottom: 30px;
    }
  }
  @media (max-width: 856px){
    .font-value{
      font-size: 18px;
    }
  }
  @media (max-width: 767px){
    select.claimTextBox {
      width: 200px;
      position: relative;
    }
    .delete-row{
      padding-right:2;
    }
  }
</style>